import { Banner } from "./sections/Banner";
import Footer from "./sections/Footer";
import Lifecycle from "./sections/Lifecycle";
import Mission from "./sections/Mission";
import Product from "./sections/Product";
import Vision from "./sections/Vision";

function App() {
  return (
    <div className="max-w-screen">
      <Banner />
      <Vision />
      <Mission />
      <Product />
      <Lifecycle />
      <Footer />
    </div>
  );
}

export default App;
